enum ApiBaseName {
  COMMUNDA = 'api/engine-rest',
  COMMUNDA_EXT = 'api/camunda-extension',
  ESS = 'api/ess/v1',
  DICT = 'api/dict/v1',
  UMS = 'api/ums/v1',
  DMS = 'api/dms/v1',
  REQUISITION = 'api/requisition/v1',
  STRAPI = 'api',
}

export default ApiBaseName;
